(function() {
  'use strict';

  // Only run on mobile
  if (window.innerWidth > 991) return;

  var overlay = null;
  var isOpen = false;

  // Menu items - pulled from the theme's nav
  var menuItems = [
    { text: 'Home', url: '/' },
    { text: 'Browse', url: '/collections/all' },
    { text: 'Our Story', url: '/pages/about-us' },
    { text: 'How It Works', url: '/#how_it_works' },
    { text: 'Blogs', url: '/blogs/news' }
  ];

  function createOverlay() {
    overlay = document.createElement('div');
    overlay.id = 'mobile-menu-overlay';
    overlay.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;height:100dvh;background:#ffffff;z-index:999999;display:flex;flex-direction:column;padding:80px 32px 32px;box-sizing:border-box;';

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 14 14" fill="none"><path d="M12 2L2 12" stroke="#000" stroke-width="1.5" stroke-linecap="round"/><path d="M12 12L2 2" stroke="#000" stroke-width="1.5" stroke-linecap="round"/></svg>';
    closeBtn.style.cssText = 'position:absolute;top:24px;right:24px;background:none;border:none;cursor:pointer;padding:8px;';
    closeBtn.addEventListener('click', closeMenu);
    overlay.appendChild(closeBtn);

    // Menu links
    var nav = document.createElement('nav');
    nav.style.cssText = 'display:flex;flex-direction:column;gap:16px;';
    menuItems.forEach(function(item) {
      var a = document.createElement('a');
      a.href = item.url;
      a.textContent = item.text;
      a.style.cssText = 'font-size:28px;font-weight:700;color:#000;text-decoration:none;padding:8px 0;';
      a.addEventListener('click', function() { closeMenu(); });
      nav.appendChild(a);
    });
    overlay.appendChild(nav);

    // Book free scan button at bottom
    var cta = document.createElement('a');
    cta.href = '/pages/book-free-scan';
    cta.textContent = 'Book free scan';
    cta.style.cssText = 'margin-top:auto;display:inline-block;background:linear-gradient(135deg,#a855f7,#7c3aed);color:#fff;padding:16px 32px;border-radius:50px;text-align:center;font-size:16px;font-weight:600;text-decoration:none;';
    overlay.appendChild(cta);
  }

  function openMenu() {
    if (isOpen) return;
    isOpen = true;
    if (!overlay) createOverlay();
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!isOpen) return;
    isOpen = false;
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
    document.body.style.overflow = '';
    // Also close the theme's details element
    var details = document.getElementById('Details-menu-drawer-container');
    if (details) details.removeAttribute('open');
  }

  // Watch for the details element to get 'open' attribute
  function init() {
    var details = document.getElementById('Details-menu-drawer-container');
    if (!details) {
      setTimeout(init, 200);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.attributeName === 'open') {
          if (details.hasAttribute('open')) {
            openMenu();
          } else {
            closeMenu();
          }
        }
      });
    });

    observer.observe(details, { attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
